/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Skip_UpdateInputs */

const en_skip_update = /** @type {(inputs: Skip_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip Update`)
};

const fr_skip_update = /** @type {(inputs: Skip_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorer la mise à jour`)
};

const de_skip_update = /** @type {(inputs: Skip_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisierung überspringen`)
};

const it_skip_update = /** @type {(inputs: Skip_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salta l'aggiornamento`)
};

const ru_skip_update = /** @type {(inputs: Skip_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пропустить обновление`)
};

const es_skip_update = /** @type {(inputs: Skip_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omitir actualización`)
};

const zh_cn2_skip_update = /** @type {(inputs: Skip_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跳过更新`)
};

const ja_skip_update = /** @type {(inputs: Skip_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新をスキップ`)
};

const hi_skip_update = /** @type {(inputs: Skip_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपडेट छोड़ें`)
};

const pt_pt2_skip_update = /** @type {(inputs: Skip_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pular atualização`)
};

/**
* | output |
* | --- |
* | "Skip Update" |
*
* @param {Skip_UpdateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const skip_update = /** @type {((inputs?: Skip_UpdateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Skip_UpdateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_skip_update(inputs)
	if (locale === "de") return de_skip_update(inputs)
	if (locale === "it") return it_skip_update(inputs)
	if (locale === "ru") return ru_skip_update(inputs)
	if (locale === "es") return es_skip_update(inputs)
	if (locale === "zh-CN") return zh_cn2_skip_update(inputs)
	if (locale === "ja") return ja_skip_update(inputs)
	if (locale === "hi") return hi_skip_update(inputs)
	if (locale === "pt-PT") return pt_pt2_skip_update(inputs)
	return en_skip_update(inputs)
});